import React, { createContext } from 'react';

const OpenEndContext = createContext({});

export { OpenEndContext };
